//! pertains to iMIS OOB functionality

import { Helper } from "../helpers/helper";
import { PopupUtility } from "./popup.utility";
import { UrlUtility } from "./url.utility";

/**
 * Opens the iMIS Image Manager in a popup window and invokes the callback with the selected image's site-relative URL once the user picks one, replicating the out-of-the-box image selection flow used by iMIS content editing fields.
 * @param callback Invoked with the selected image's site-relative URL (origin stripped) once an image has been chosen. Not invoked if the popup is dismissed without a selection.
 */
function selectImageManagerImage(callback) {
    getImageManagerUrl(function (imageManagerPopupData) {
        setupImageManagerWindow(imageManagerPopupData);

        PopupUtility.createPopup({
            url: imageManagerPopupData.url,
            title: "Select Image",
            width: imageManagerPopupData.width,
            height: imageManagerPopupData.height,
            callback: function (sender, args) {
                // reset auto size
                sender.set_autoSize(false);

                // get the selected image if any
                let argValue = args.get_argument();
                if (argValue != null) {
                    let imgSrc = argValue.get_value()[0].src;
                    let cleanImgSrc = imgSrc.replace(location.origin, "");

                    callback(cleanImgSrc);
                }
            }
        });
    });
}

/**
 * Loads the Image Manager page in a hidden iframe, triggers its popup to open so the active Telerik RadWindow can be captured, then removes the iframe and reports the Image Manager popup's URL and dialog parameters.
 * @param callback Invoked with an object containing the Image Manager popup's `url` and `dialogParameters` once they have been determined.
 */
function getImageManagerUrl(callback) {
    let imageManagerPageUrl = getImageManagerPageUrl();

    // setup a "hidden" iFrame that loads the image manager page url
    let jIframe = jQuery("<iframe style='display: none; height: 1000px; width: 100%;' src='" + imageManagerPageUrl + "' />");
    jIframe.on("load", function () {
        let contentWindow = (<HTMLIFrameElement>this).contentWindow;
        contentWindow.jQuery(function () {
            // inside the iframe trigger a click so the popup opens again (to ensure we get the popup active window after it has been created)
            contentWindow.jQuery("[id$=_ContentPanel]>input").trigger("click");
            let activeWindow = contentWindow.GetRadWindowManager().getActiveWindow();

            // get the Image Manager url and dimensions
            let callbackData = {
                url: activeWindow.get_navigateUrl(),
                dialogParameters: activeWindow["DialogParameters"]
            }

            jIframe.remove();
            callback(callbackData);
        });
    });

    jQuery("form").append(jIframe);
}

/**
 * Resolves the URL of the Image Manager page, preferring the link found in the staff site's side navigation tree and falling back to the hardcoded default path if it cannot be found, with the "E" template type parameter appended.
 * @returns The Image Manager page URL, including its query parameters.
 */
function getImageManagerPageUrl() {
    let imageManagerPageUrl = "";

    // get the page url from the side navigation available on the staff site
    let tRadTree: Telerik.Web.UI.RadTreeView = $find(jQuery("[id$=_SubNavigationTree]").attr("id"));
    if (tRadTree != null) {
        let tNode = tRadTree.findNodeByText("Manage images");
        if (tNode != null) {
            imageManagerPageUrl = tNode.get_navigateUrl();
        }
    }

    // if not found, default to hardcoded URL
    if (Helper.isStringNullOrEmpty(imageManagerPageUrl)) {
        imageManagerPageUrl = "/iMIS/ContentManagement/ImageManager.aspx";
    }

    imageManagerPageUrl = UrlUtility.getUrlStringWithParams(imageManagerPageUrl, {
        TemplateType: "E"
    });
    return imageManagerPageUrl;
}

/**
 * Configures the shared "GenericWindow" Telerik RadWindow for displaying the Image Manager, wiring up dialog parameters (if provided) to be applied before the window shows and enabling auto-sizing.
 * @param imageManagerPopupData The Image Manager popup data (URL and optional dialog parameters) used to configure the RadWindow.
 */
function setupImageManagerWindow(imageManagerPopupData) {
    // check for dialogParameters and add callback to add them to the RadWindow object before frame loads
    let radWindow = window.GetRadWindowManager().getWindowByName("GenericWindow");
    if (imageManagerPopupData.dialogParameters != null) {
        const cb = function (sender, args) {
            sender.DialogParameters = imageManagerPopupData.dialogParameters;
            sender.remove_beforeShow(cb);
        };

        radWindow.add_beforeShow(cb);
    }
    radWindow["ClientParameters"] = {};
    radWindow.set_autoSize(true);
}

export {
    selectImageManagerImage
};
